<template>
  <div class="container">
    <div class="tabs">
      <div class="title">灌溉管理</div>
      <div class="tabWrap">
        <van-tabs key="diguan" v-model="active" title-active-color="#3364DB">
          <van-tab title="星期"></van-tab>
          <van-tab title="月份"></van-tab>
          <van-tab title="生育期"></van-tab>
        </van-tabs>
      </div>

    </div>

    <div class="body">
      <div>
        <div class="time">
          <div class="num">
            <span>累计：</span>
            <span class="hour">{{active == 0 ? hour :active == 1 ?  monthHour:growHour }}</span>&nbsp;
            <span>小时</span>
          </div>
          <div v-if="active == 0">
            <div class="flex-row items-center section_4 space-x-14" @click="handleClickWeek">
              <span class="font_3 text_5">第 {{ currentWeekIndex + 1}} 周</span>
              <img class="shrink-0 image" src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/64489f9d5a7e3f0310f71776/6461034fb98f5d0011697b8a/16931902968700510761.png" />
            </div>
          </div>

          <!-- <div v-if="active == 2">
            <div class="flex-row items-center section_4 space-x-14" @click="showGrowPicker = true">
              <span class="font_3 text_5">{{currentGrowIndex > -1 ?   growRange[currentGrowIndex].shortCall:  '请选择' }}</span>
              <img class="shrink-0 image" src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/64489f9d5a7e3f0310f71776/6461034fb98f5d0011697b8a/16931902968700510761.png" />
            </div>
          </div> -->
        </div>

        <!-- 图表容器 -->
        <div id="echartsWrap" style="width: 100%; height: 4.5rem;"> </div>
      </div>

    </div>

    <van-popup v-model="showWeekPicker" round position="bottom">
      <van-picker title="星期" show-toolbar :columns="range" :default-index="currentWeekIndex" value-key="label" @confirm="onConfirm" @cancel="showWeekPicker=false" />
    </van-popup>

    <!-- <van-popup v-model="showGrowPicker" round position="bottom">
      <van-picker title="生育期" show-toolbar :columns="growRange" :default-index="currentWeekIndex" value-key="shortCall" @confirm="onConfirmGrow" @cancel="showGrowPicker=false" />
    </van-popup> -->

    <div class="loadingWrap" v-if="loading">
      <van-loading type="spinner" color="#1989fa" />
      <div style="margin-top: 10px; color: #1989fa; font-size: 14px;">数据加载中...</div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import echarts from 'echarts';

import Worker from 'worker-loader!./worker.js';

const oneDay = 1000 * 60 * 60 * 24 * 1;


export default {
  props: {
    refresh: {
      default: false,
      type: Boolean
    }
  },

  data () {
    return {
      no: localStorage.getItem("no") ? localStorage.getItem("no") : "",
      active: 0,
      currentWeekIndex: 0, // 当前时间是在第几周
      currentGrowIndex: -1, // 当前生育期是在哪个期间
      range: [],
      hour: 0,
      monthHour: 0,
      growHour: 0,
      showWeekPicker: false,
      chart: null,
      options: {},
      // 获取当前年份的第一天
      firstDayOfYear: moment().startOf('year'),
      // 获取去年的最后一天
      lastDayOfYear: moment().endOf('year'),
      monthOptions: null, // 缓存月份图表数据，避免重新查询 耗时
      weekOptions: null, // 缓存月份图表数据，避免重新查询 耗时
      loading: false,
      showGrowPicker: false,
      growRange: [],
      growOptions: null,
      yearAllData: [],
      cgqDictIndex: null
    }
  },

  watch: {
    async active (val) {
      this.chart?.clear();
      // 销毁当前的实例
      this.chart.dispose(document.getElementById('echartsWrap'));
      this.chart = echarts.init(document.getElementById('echartsWrap'));
      if (val == 0) {
        if (this.weekOptions) this.chart.setOption(this.weekOptions);
        else this.init()
      } else if (val == 1) {
        if (this.monthOptions) this.chart.setOption(this.monthOptions);
        else this.getData(this.firstDayOfYear.format('YYYY/MM/DD'), this.lastDayOfYear.format('YYYY/MM/DD'))
      } else {
        // 生育期
        if (this.growOptions) this.chart.setOption(this.growOptions);
        else {
          this.getData(this.firstDayOfYear.format('YYYY/MM/DD'), this.lastDayOfYear.format('YYYY/MM/DD'))
        }
      }
    },

    refresh (bl) {
      bl && this.refresh()
    }
  },

  async mounted () {
    this.chart = echarts.init(document.getElementById('echartsWrap'));
    await this.$api.getCgqAttr({ no: this.no })
      .then(res => {
        if (res.errcode == 0) {
          const find = res?.list.find(o => o.index == 59)
          if (find) { this.cgqDictIndex = find.index }
        }
      })
    await this.getFarmInfo()
    if (this.cgqDictIndex != null) {
      await this.queryGrowPeriod()
      this.active = 2
    }

  },

  methods: {
    async init () {
      // 获取当前日期所在年份的第几个星期
      const currentWeekOfYear = moment().isoWeek();
      const weeks = [];
      // 循环遍历每个星期
      let currentDate = moment(this.firstDayOfYear.format("YYYY/MM/DD")).startOf("YYYY/MM/DD")
      while (currentDate <= this.lastDayOfYear) {
        const weekDates = [];
        // 循环遍历每个星期的七天
        for (let i = 0; i < 7; i++) {
          const day = {
            date: currentDate.format('YYYY-MM-DD'),
            day: currentDate.format('MM-DD'),
            dayOfWeek: this.convertToChineseNumber(currentDate.day())
          };
          weekDates.push(day);
          currentDate = currentDate.add(1, 'day');
        }
        weeks.push({ week: weekDates, label: `第${weeks.length + 1}周 ${weekDates[0].day} ~ ${weekDates[weekDates.length - 1].day}` });
      }
      this.range = weeks.splice(0, currentWeekOfYear)
      this.currentWeekIndex = currentWeekOfYear - 1

      const { week } = this.range[currentWeekOfYear - 1]

      if (this.yearAllData.length) {

      } else {
        await this.getData(week[0].date, week[week.length - 1].date)
      }
    },

    async getFarmInfo () {
      await this.$api.queryFarm(this.no).then(res => {
        this.farmInfo = res.data;
      })
    },

    async queryGrowPeriod () {
      await this.$api.queryGrowPeriod(this.farmInfo.cropClass.id).then(res => {
        if (res.errcode === 0) {
          this.growRange = res.list.map(item => {
            item.startDate = new Date().getFullYear() + "-" + item.startDate
            item.endDate = new Date().getFullYear() + "-" + item.endDate
            item.sTemp = new Date(`${item.startDate.replaceAll("-", "/")} 00:00:0`).getTime()
            item.eTemp = new Date(`${item.endDate.replaceAll("-", "/")} 23:59:59`).getTime()
            item.mSecond = 0
            return item
          })
          // 锁定到当前的生育期
          const tar = this.farmInfo?.myCropList[this.farmInfo.myCropList.length - 1]
          const findIndex = this.growRange.findIndex(o => o.id == tar.periodId)
          // 生育期
          if (this.growRange.length) {
            this.currentGrowIndex = findIndex > -1 ? findIndex : 0
          }
        }
      })
    },


    convertToChineseNumber (number) {
      const chineseNumbers = ['日', '一', '二', '三', '四', '五', '六'];
      return chineseNumbers[number];
    },

    async getData (time1, time2) {
      this.loading = true
      // 如果天数上大于7天的，则拆分为多个7天的小组 进行请求 然后拼接
      let st = new Date(time1?.replaceAll?.("-", "/")).getTime(),
        et = new Date(time2?.replaceAll?.("-", "/")).getTime();
      let spliceDays = [];
      // 开始时间加上7天时间， 如果小于结束时间

      let days = 7

      if (this.active == 0) { days = 7 }
      else { days = 10 }


      while (st + oneDay * days < et) {
        spliceDays.push({
          sT: this.$setime(st, 2),
          // 7天后的日期
          eT: this.$setime(st + oneDay * days, 2)
        });
        // 加到7天的下一天 就是第8天
        st += oneDay * (days);

        // 结束时间 et 是否是某个月的1号
        const date = moment(st + oneDay * days)
        if (date.date() === 1 && date.startOf('day').isSame(date.startOf('month'), 'day')) {
          console.log("是某个月的第一天:", moment(st).format("YYYY-MM-DD"));

          // 则往后推2天
          st += oneDay
        }
      }

      spliceDays.push({
        sT: this.$setime(st, 2),
        eT: this.$setime(et, 2)
      });

      console.log("spliceDays:", this.cgqDictIndex, spliceDays);

      let reqList = [];

      spliceDays.map(async item => {
        reqList.push(
          this.$api.getDataBySensor({
            no: this.no,
            startTime: item.sT,
            endTime: item.eT,
            dictIndex: this.cgqDictIndex
          })
        );
      });
      let dataList = [];

      await Promise.all(reqList)
        .then(res => {
          this.$toast.clear();
          res.map(item => {
            if (!this.$isblank(item.data)) {
              dataList = dataList.concat(item.data);
            }
          });

          if (!this.$isblank(dataList)) {
            const worker = new Worker()
            worker.postMessage({ list: dataList, growRange: this.growRange, active: this.active });
            worker.onmessage = (e) => {
              const { list: dataList, growRange } = e.data
              console.log("worker res:", res);

              const list = [...dataList];

              const growXData = [], growYData = [];

              if (this.active == 1) {
                // 查月份 是具有所有的数据的
                this.yearAllData = [...list]
              }

              let growHour = 0
              growRange.map(item => {
                const t = this.caculationTime(item.mSecond)
                growXData.push(this.addNewline(item.shortCall))
                growYData.push(t)
                growHour += Number(t)
              })

              this.growRange = [...growRange]
              console.log("growRange:", growRange);

              console.log("listlistlist:", list);

              this.growHour = growHour.toFixed(2)
              let xData = [], yData = [];
              let monXData = {}, monYData = {};

              // 根据星期 还是 月份进行数据拆解
              list.map(o => {
                // 星期
                if (this.active == 0) {
                  if (o.mSecond > 0) { o.duration = this.caculationTime(o.mSecond); }
                  xData.push(`${o.sDate}\n${o.week}`)
                  yData.push(o.duration || 0)
                } else {
                  // 月份
                  const group = list.reduce(function (result, item) {
                    var date = new Date(item.date?.replaceAll?.("-", "/"));
                    var month = date.getMonth() + 1;
                    var key = month;
                    if (!result[key]) { result[key] = 0 }
                    result[key] += item.mSecond
                    return result;
                  }, {})
                  monXData = Object.keys(group).map(o => `${o}月`)
                  monYData = Object.values(group).map(o => this.caculationTime(o))
                }
              });


              console.log("growXData:", growXData);
              console.log("growYData:", growYData);

              if (this.active == 0) {
                this.weekOptions = this.setBarOptions(xData, yData)
                this.hour = Number(yData.reduce(function (res, item) { res += Number(item); return res }, 0)).toFixed(2)
              } else {
                this.monthOptions = this.setBarOptions(monXData, monYData)
                this.monthHour = Number(monYData.reduce(function (res, item) { res += Number(item); return res }, 0)).toFixed(2)

                this.growOptions = this.setBarOptions(growXData, growYData)
                this.growHour = Number(growYData.reduce(function (res, item) { res += Number(item); return res }, 0)).toFixed(2)
              }

              let options = this.active == 0 ? this.weekOptions : this.active == 1 ? this.monthOptions : this.growOptions
              options && this.chart.setOption(options);
            }
          }
          this.loading = false
        })
        .catch(err => {
          // 其他异常
          this.$toast.clear();
          console.error("err:", err);
          // this.$toast(`查询异常: ${err?.errmsg}`);
          this.loading = false
        });
    },

    addNewline (str) {
      var result = '';
      for (var i = 0; i < str.length; i += 2) {
        result += str.substr(i, 2) + '\n';
      }
      return result;
    },


    caculationTime (time) {
      const temp = 1000;
      const s_unit = 1 * temp;
      const m_unit = 60 * s_unit;
      const h_unit = 60 * m_unit;
      const hour = Number(time / (h_unit)).toFixed(2)
      return String(hour);
    },

    setBarOptions (xData, yData,) {
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params) {
            const { marker, value, axisValue } = params[0]
            return `<div><div>${axisValue.substring(0, 6)}</div><div>${marker} ${value} 小时</div></div>`
          }
        },
        grid: {
          top: '10%',   // 上边距占图表高度的百分比
          bottom: this.active == 0 ? '20%' : this.active == 1 ? '10%' : '20%',   // 下边距占图表高度的百分比
          left: '10%',   // 左边距占图表宽度的百分比
          right: '4%'   // 右边距占图表宽度的百分比
        },
        xAxis: {
          type: 'category',
          data: xData,
          splitLine: {
            show: false  // 不展示纵向的分隔线
          },
          axisLabel: {
            interval: 0, // 设置为 0，强制显示所有标签
          }
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                // 设置横向的分隔线为虚线
                type: 'dashed'
              }
            },
            axisLine: {
              show: false  // 隐藏 y 轴线
            },
            axisTick: {
              show: false  // 隐藏 y 轴刻度线
            },
            axisLabel: {  // 设置 y 轴标签样式
              show: true,
              textStyle: {
                color: '#000',
                fontSize: 12
              }
            },
          }, {
            type: 'value',
            position: 'right',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false  // 隐藏 y 轴线
            },
            axisTick: {
              show: false  // 隐藏 y 轴刻度线
            },
          }
        ],
        series: [
          {
            data: yData,
            type: 'bar',
            itemStyle: {
              color: '#3364DB',  // 修改柱子的颜色，这里以红色为例
              barBorderRadius: [4, 4, 0, 0]
            },
            label: {
              show: true,
              position: 'top'  // 设置标签显示位置为顶部
            }
          }
        ]
      };
      return option
    },



    handleClickWeek () {
      console.log("123");
      this.showWeekPicker = true
    },

    onConfirm (val, index) {
      this.currentWeekIndex = index
      this.showWeekPicker = false
      // 请求数据
      const { week } = this.range[index]
      this.getData(week[0].date, week[week.length - 1].date)
    },

    onConfirmGrow (val, index) {
      this.currentGrowIndex = index
      this.showGrowPicker = false
      const { startDate, endDate } = this.growRange[index]
      this.getData(startDate, endDate)
    }
  }

}
</script>

<style lang="scss"  scoped>
@import "./../../codeFunCommon.scss";
.container {
  position: relative;
  width: 100%;
  background: #ffffff;
}

.tabs {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;

  .title {
    position: absolute;
    width: 65px;
  }

  .tabWrap {
    width: calc(100% - 65px);
    margin-left: 65px;
  }

  ::v-deep .van-tabs__line {
    background: #3364db;
  }
}

.body {
  position: relative;
  min-height: 200px;
  padding: 10px;
  margin-bottom: 20px;

  .time {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;

    .num {
      font-size: 14px;
      font-family: Roboto;

      .hour {
        color: #3364db;
        font-size: 19px;
      }
    }

    .font_3 {
      font-size: 14px;
      font-family: PingFang SC;
      line-height: 13px;
      color: #40464b;
    }
    .section_4 {
      border-radius: 4px;
      height: 32px;
      border: solid 1px #2a85ff;
      display: flex;
      align-items: center;
      padding: 0 8px;
    }
    .space-x-14 > *:not(:first-child) {
      margin-left: 14px;
    }
    .text_5 {
      color: #2a85ff;
    }
    .image {
      width: 9px;
      height: 6px;
    }
  }
}

.loadingWrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  opacity: 0.5;
  background: rgba(255, 255, 255, 0.5);
  align-items: center;
  justify-content: center;
}
</style>
